var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4531 13.9766L17.7031 12.7266C17.8984 12.5312 18.25 12.6875 18.25 12.9609V18.625C18.25 19.6797 17.3906 20.5 16.375 20.5H2.625C1.57031 20.5 0.75 19.6797 0.75 18.625V4.875C0.75 3.85938 1.57031 3 2.625 3H13.2891C13.5625 3 13.7188 3.35156 13.5234 3.54688L12.2734 4.79688C12.1953 4.875 12.1172 4.875 12.0391 4.875H2.625V18.625H16.375V14.2109C16.375 14.1328 16.375 14.0547 16.4531 13.9766ZM22.5469 6.125L12.3125 16.3594L8.75781 16.75C7.74219 16.8672 6.88281 16.0078 7 14.9922L7.39062 11.4375L17.625 1.20312C18.5234 0.304688 19.9688 0.304688 20.8672 1.20312L22.5469 2.88281C23.4453 3.78125 23.4453 5.22656 22.5469 6.125ZM18.7188 7.29688L16.4531 5.03125L9.1875 12.2969L8.875 14.875L11.4531 14.5625L18.7188 7.29688ZM21.2188 4.21094L19.5391 2.53125C19.3828 2.33594 19.1094 2.33594 18.9531 2.53125L17.7812 3.70312L20.0469 6.00781L21.2578 4.79688C21.4141 4.60156 21.4141 4.36719 21.2188 4.21094Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/change-icon.dc339299f4abe7457f1bce77170bae8c.svg";
export { ForwardRef as ReactComponent };